var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('a',{attrs:{"href":"https://infoguia.com/","target":"_blank"}},[_vm._v("Infoguia")]),_c('span',{staticClass:"ml-1"},[_vm._v("2021")])]),_c('div',{staticClass:"ml-auto"},[_c('span',{staticClass:"mr-1"},[_vm._v("Desarrollado por "),_c('b',[_vm._v("Infoguia")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }